import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LagunaCreekLogo from "../../assets/lagunacreek-logo.svg";
import LinkedIn from "../../assets/linkedIn.svg";
import Instagram from "../../assets/instagram.svg";
import Facebook from "../../assets/facebook.svg";
import Phone from "../../assets/phone.svg";
import Email from "../../assets/email.svg";
import { routeList } from "../../config/routeConfig";
 
const Footer = () => {
  const navigationItems = routeList.filter((a) => a.showMenuBar);
  const [footerData, setFooterData] = useState(null);
 
  useEffect(() => {
    fetch("https://www.lagunacreek.io/blog/wp-json/custom/v1/footer-settings")
      .then((res) => res.json())
      .then((data) => setFooterData(data))
      .catch((error) => {
        console.error("Failed to load footer data:", error);
        setFooterData(null);
      });
  }, []);
 
  // ✅ Load HubSpot tracking script from WordPress
  useEffect(() => {
    fetch("https://www.lagunacreek.io/blog/wp-json/custom/v1/tracking-scripts")
      .then((res) => res.json())
      .then((data) => {
        if (data?.hubspot_script) {
          const script = document.createElement("script");
          script.src = data.hubspot_script;
          script.async = true;
          script.defer = true;
          script.id = "hs-script-loader";
          document.body.appendChild(script);
        }
      })
      .catch((err) => console.log("Tracking script error:", err));
  }, []);
 
  const socialIcons = [
    {
      defaultIcon: <div className="font-bold text-white">X</div>,
      fallbackLink: "https://x.com/laguna_creek",
    },
    { icon: Facebook, fallbackLink: "https://www.facebook.com/profile.php?id=61564408615596" },
    { icon: Instagram, fallbackLink: "https://www.instagram.com/lagunacreek2024/" },
    { icon: LinkedIn, fallbackLink: "https://www.linkedin.com/company/lcpms" },
  ];
 
  return (
<footer className="pt-10 md:pt-16 pb-5 border-t border-[#E7E7E7]">
<div className="w-full max-w-[1570px] px-4 mx-auto">
<div className="flex flex-wrap justify-between -mx-4 gap-y-[32px]">
 
          {/* Logo + About */}
<div className="w-full xl:w-auto px-4">
<div className="flex flex-col gap-[35px] xl:max-w-[398px]">
<Link to="/">
<img
                  src={footerData?.footer_logo || LagunaCreekLogo}
                  alt="Laguna Creek Logo"
                  className="w-auto"
                />
</Link>
 
              <p className="text-lg font-light leading-7 text-[#192020]">
                {footerData?.footer_about_us_text ||
                  "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land."}
</p>
 
              <div className="flex items-center gap-3">
                {(footerData?.social_media || []).length
                  ? footerData.social_media.map((item, index) => (
<Link
                        key={index}
                        to={item.social_icon_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex justify-center items-center w-[34px] h-[34px] bg-[#D4D4D4] border border-[#D4D4D4] rounded-full hover:bg-[#5fa3b2]"
>
<img src={item.social_icon} alt="" />
</Link>
                    ))
                  : socialIcons.map((icon, index) => (
<Link
                        key={index}
                        to={icon.fallbackLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex justify-center items-center w-[34px] h-[34px] bg-[#D4D4D4] border border-[#D4D4D4] rounded-full hover:bg-[#5fa3b2]"
>
                        {icon.icon ? <img src={icon.icon} alt="" /> : icon.defaultIcon}
</Link>
                    ))}
</div>
</div>
</div>
 
          {/* Company Links */}
<div className="w-auto md:w-1/3 lg:w-auto px-4">
<h2 className="text-[22px] mb-5">
              {footerData?.company_title || "Company"}
</h2>
 
            <ul className="flex flex-col items-center gap-[22px]">
              {(footerData?.company || navigationItems).map((item, index) => (
<li key={index} className="w-full">
                  {item.company_menu_title ? (
<Link
                      to={item.company_menu_link}
                      dangerouslySetInnerHTML={{ __html: item.company_menu_title }}
                      className="text-lg font-light text-[#333]"
                    />
                  ) : (
<Link
                      to={item.path}
                      className="text-lg font-light text-[#333]"
>
                      {item.menuLabel}
</Link>
                  )}
</li>
              ))}
</ul>
</div>
 
          {/* Website Menu */}
<div className="w-auto md:w-1/3 lg:w-auto px-4">
<h2 className="text-[22px] mb-5">
              {footerData?.website_title || "Website"}
</h2>
 
            <ul className="flex flex-col items-center gap-[22px]">
              {(footerData?.website_menu || [
                { website_menu_text: "Privacy Policy", website_menu_link: "/privacy-policy" },
                { website_menu_text: "Terms of Use", website_menu_link: "/terms-of-use" },
              ]).map((item, index) => (
<li key={index}>
<Link to={item.website_menu_link}>
                    {item.website_menu_text}
</Link>
</li>
              ))}
</ul>
</div>
 
          {/* Contact */}
<div className="w-auto md:w-1/3 lg:w-auto px-4">
<h2 className="text-[22px] mb-5">
              {footerData?.connect_with_us_title || "Connect With Us"}
</h2>
 
            <ul className="flex flex-col gap-[7px]">
              {(footerData?.connect_with_us || [
                {
                  connect_with_us_item_icon: Phone,
                  connect_with_us_item_text: "(623) 300-2434",
                  connect_with_us_item_link: "tel:+16233002434",
                },
                {
                  connect_with_us_item_icon: Email,
                  connect_with_us_item_text: "info@lagunacreek.com",
                  connect_with_us_item_link: "mailto:info@lagunacreek.com",
                },
              ]).map((item, index) => (
<li key={index} className="flex items-center gap-[10px]">
<img src={item.connect_with_us_item_icon} alt="" />
<Link to={item.connect_with_us_item_link}>
                    {item.connect_with_us_item_text}
</Link>
</li>
              ))}
</ul>
</div>
 
        </div>
</div>
 
      {/* Copyright */}
<div className="w-full max-w-[1570px] px-4 mx-auto mt-9 border-t pt-5">
<p className="text-sm text-[#A7A7A7]">
          {footerData?.copyright_text ||
            `Copyright11 ${new Date().getFullYear()} Laguna Creek. All rights reserved.`}
</p>
</div>
</footer>
  );
};
 
export default Footer;